import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=615ea4cf&scoped=true"
import script from "./ProductContent.vue?vue&type=script&lang=js"
export * from "./ProductContent.vue?vue&type=script&lang=js"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=615ea4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ea4cf",
  null
  
)

export default component.exports